import { apiPaths } from '../config/apiPaths';
import { RestaurantUserSurveyResponse } from '../modules/Home/model/RestaurantUserSurveyResponse';
import axiosInstance from './axios';

export const getSurveyUrl = (): Promise<RestaurantUserSurveyResponse> =>
  axiosInstance.get<RestaurantUserSurveyResponse>(apiPaths.RESTAURANT_USERS_SURVEYS_PATH).then(({ data }) => data);

export const registerCustomerSurveyCompletion = (): Promise<void> =>
  axiosInstance.post(apiPaths.RESTAURANT_USERS_SURVEYS_PATH);
